import { Component, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { systemUsersRoute } from 'src/app/app-routing.module';
import { accountsToFilterOut } from 'src/app/authentication/state/authentication.selector';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { Privileges } from 'src/app/privileges/privileges';
import { UsersFilterOption } from '../../models/users-filter-option';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-system-user-register',
    templateUrl: './system-user-register.component.html',
    standalone: false
})
export class SystemUserRegisterComponent {
   systemRouterLink = systemUsersRoute;

   filters: UsersFilterOption[];

   constructor(public store: Store) {
      this.store
         .select(accountsToFilterOut(Privileges.ManageSystemUsers_View))
         .pipe(
            map((accountIds: number[]) => {
               const filters: UsersFilterOption[] = [
                  {
                     field: 'IsSystemUser',
                     operation: FilterOperations.EqualTo,
                     type: 'boolean',
                     value: true,
                  },
                  {
                     field: 'AccountId',
                     operation: FilterOperations.EqualTo,
                     type: 'numeric',
                     value: 1,
                  },
               ];
               if (accountIds.length > 0) {
                  filters.push({
                     field: 'AccountId',
                     operation: FilterOperations.NotIn,
                     type: 'numeric',
                     value: accountIds,
                  });
               }
               return filters;
            })
         )
         .subscribe((filters: UsersFilterOption[]) => {
            this.filters = filters;
         });
   }
}
